import React from 'react';
import get from 'lodash/get';
import moment from 'moment-timezone';
import { Grid, Typography } from '@mui/material';
import { localeLongDateTimeFormat } from '../../lib/utils';

function StartedAndClosedDisplay({ item, tz }) {
  return (
    <Grid container>
      {item.startedAt && (
      <Grid item xs={6} sm={6}>
        <Typography variant="caption">
          <strong>Started at:</strong>
        </Typography>
        <Typography variant="caption">
          {moment.tz(get(item, 'startedAt'), tz).format(localeLongDateTimeFormat)}
        </Typography>
      </Grid>
      )}
      {item.closedAt
      && (
      <Grid item xs={6} sm={6}>
        <Typography variant="caption">
          <strong>Closed at:</strong>
        </Typography>
        <Typography variant="caption">
          {moment.tz(get(item, 'closedAt'), tz).format(localeLongDateTimeFormat)}
        </Typography>
        <Typography variant="caption">
          by
          {' '}
          {get(item, 'closedBy.name', 'Unknown')}
        </Typography>
      </Grid>
      )}
    </Grid>
  );
}

export default StartedAndClosedDisplay;
